import { freeBoardsRemaining } from './freeBoardsRemaining';

/**
 * Checks if the organization has reached or exceeded its free boards limit.
 */
export const isAtOrOverFreeBoardLimit = <Team>(team: Team): boolean => {
  const remaining = freeBoardsRemaining(team);

  return remaining === 0;
};
